import React from 'react';
import styles from './index.module.scss';

const Spinner: React.FC = () => {
  return (
    <div className={styles.spinner}>
      <svg
        t="1677231267059"
        className="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="https://www.w3.org/2000/svg"
        p-id="2788"
        width="48"
        height="48"
      >
        <path
          d="M300.544034 796.598894q0 30.281138-21.430854 51.711992t-51.711992 21.430854q-29.695995 0-51.41942-21.723425t-21.723425-51.41942q0-30.281138 21.430854-51.711992t51.711992-21.430854 51.711992 21.430854 21.430854 51.711992zM585.142845 914.285732q0 30.281138-21.430854 51.711992t-51.711992 21.430854-51.711992-21.430854-21.430854-51.711992 21.430854-51.711992 51.711992-21.430854 51.711992 21.430854 21.430854 51.711992zM182.857196 512.000083q0 30.281138-21.430854 51.711992t-51.711992 21.430854-51.711992-21.430854-21.430854-51.711992 21.430854-51.711992 51.711992-21.430854 51.711992 21.430854 21.430854 51.711992zM869.741656 796.598894q0 29.695995-21.723425 51.41942t-51.41942 21.723425q-30.281138 0-51.711992-21.430854t-21.430854-51.711992 21.430854-51.711992 51.711992-21.430854 51.711992 21.430854 21.430854 51.711992zM318.829746 227.401272q0 37.741708-26.843424 64.585132t-64.585132 26.843424-64.585132-26.843424-26.843424-64.585132 26.843424-64.585132 64.585132-26.843424 64.585132 26.843424 26.843424 64.585132zM987.428494 512.000083q0 30.281138-21.430854 51.711992t-51.711992 21.430854-51.711992-21.430854-21.430854-51.711992 21.430854-51.711992 51.711992-21.430854 51.711992 21.430854 21.430854 51.711992zM621.714268 109.714434q0 45.714278-32.036566 77.677702t-77.677702 32.036566-77.677702-32.036566-32.036566-77.677702 32.036566-77.677702 77.677702-32.036566 77.677702 32.036566 32.036566 77.677702zM924.59879 227.401272q0 53.174849-37.741708 90.550842t-90.258271 37.449137q-53.174849 0-90.550842-37.449137t-37.449137-90.550842q0-52.589706 37.449137-90.258271t90.550842-37.741708q52.589706 0 90.258271 37.741708t37.741708 90.258271z"
          fill="#444444"
          p-id="2789"
        />
      </svg>
    </div>
  );
};

export default Spinner;
